import {useEffect} from "react";

export default function ResultBodyCell({children, style = {}, ...props}) {

    return (
        <td
            style={{
                border: '1px solid #e0e0e0',
                paddingLeft: 4,
                paddingRight: 4,
                wordWrap: 'break-word',
                ...style
            }}
            {...props}
        >
            {children}
        </td>
    )
}